import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { GraduationCap, Loader2, CalendarCheck, CalendarX } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Modules certifiants d'une AF sans AFT : ligne(s) avec bouton « Créer l'AFT »
export const AftsManquantesInline = ({ dossierId, onCreated, className = '' }) => {
  const [modules, setModules] = useState([]);
  const [saving, setSaving] = useState(false);
  const load = () => axios.get(`${API_URL}/dossiers-afts-manquantes`).then(r => setModules((r.data || []).find(d => d.id === dossierId)?.modules || [])).catch(() => setModules([]));
  useEffect(() => { if (dossierId) load(); }, [dossierId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!dossierId || modules.length === 0) return null;
  const creer = async () => {
    setSaving(true);
    try {
      const r = await axios.post(`${API_URL}/dossiers/${dossierId}/sync-afts`);
      toast.success(r.data.creees.length ? `AFT créée(s) : ${r.data.creees.map(a => a.code).join(', ')}` : 'Aucune AFT à créer');
      await load(); onCreated?.(r.data.creees || []);
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); } finally { setSaving(false); }
  };
  return (
    <div className={`rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 flex items-center justify-between gap-3 flex-wrap ${className}`} data-testid={`afts-manquantes-inline-${dossierId}`}>
      <div className="text-xs text-amber-900 min-w-0">
        <p className="font-semibold flex items-center gap-1.5"><GraduationCap className="w-3.5 h-3.5" /> {modules.length} module(s) certifiant(s) sans action de certification (AFT)</p>
        <div className="flex flex-wrap gap-1.5 mt-1">
          {modules.map(m => (
            <span key={m.id} className={`inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded font-medium ${m.planifie ? 'bg-emerald-100 text-emerald-800' : 'bg-white border border-amber-300 text-amber-800'}`} title={m.planifie ? 'Planifié dans le planning pédagogique' : 'Non planifié : l\'AFT sera créée sans date'} data-testid={`aft-manquante-module-${m.id}`}>
              {m.planifie ? <CalendarCheck className="w-3 h-3" /> : <CalendarX className="w-3 h-3" />} {m.code} — {m.titre}
            </span>
          ))}
        </div>
      </div>
      <button type="button" onClick={creer} disabled={saving} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold bg-cyan-600 text-white hover:bg-cyan-700 disabled:opacity-50 shrink-0" data-testid={`creer-aft-manquante-${dossierId}`}>
        {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <GraduationCap className="w-3.5 h-3.5" />} Créer {modules.length > 1 ? 'les AFT manquantes' : "l'AFT manquante"}
      </button>
    </div>
  );
};
